// A dead end should still tell you where you are and offer the way back — on a phone especially,
// where there is no visible browser chrome once the app is installed to the home screen.
import { Link, useNavigate } from 'react-router-dom';
import { t } from '../i18n/index.ts';
import { AlignovaMark } from '../ui/AlignovaLogo.tsx';
import { IconArrowLeft } from '../ui/icons.tsx';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-full place-items-center p-6">
      <div className="w-full max-w-sm text-center">
        <span className="mx-auto mb-5 grid h-14 w-14 place-items-center rounded-xl bg-surface-2 text-muted">
          <AlignovaMark className="h-9 w-9" />
        </span>
        <p className="tabnum font-mono text-4xl font-semibold text-muted">404</p>
        <p className="mt-2 text-lg font-semibold text-ink">{t('common.notFound')}</p>
        <p className="mx-auto mt-1 max-w-[38ch] text-sm text-muted">
          The page may have been moved, or the link that brought you here is out of date.
        </p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
          <button
            onClick={() => navigate(-1)}
            className="tap inline-flex items-center justify-center gap-2 rounded-md border border-line px-4 py-2.5 text-sm font-medium text-ink"
          >
            <IconArrowLeft size={18} />
            Go back
          </button>
          <Link
            to="/"
            className="tap inline-flex items-center justify-center rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-primary-fg"
          >
            {t('nav.dashboard')}
          </Link>
        </div>
      </div>
    </div>
  );
}
